/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha Dhanireddy <snigdha.dhanireddy@mroads.com>, October 2020
 * @format
 * @flow
 */

import { ActionTypes } from '../constants';

export function saLoginAction(payload) {
  return {
    type: ActionTypes.SA_LOGIN_REQUEST,
    payload,
  };
}


